import React, { Component } from 'react';

import { distanceOrTown } from 'Common/distanceOrTown';

// Components
import Card from 'Common/Card';
import Carousel from 'Common/Carousel';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { valueOrNA } from 'Common/valueOrNA';
import styles from 'components/AlsoConsider.scss';
import { gtmAlsoConsiderClick } from 'Common/gtmPayloads';
import isWindow from 'Common/isWindow';
import isWindowProp from 'Common/isWindowProp';
import { getDerivativeDisplayName } from 'utils/derivative';

const parsedPrice = itemPrice => {
  return itemPrice === 999999999 ? 'POA' : `£${itemPrice.toLocaleString('en')}`;
};

/**
 * <CardsCarousel /> component.
 * @return {class} new AlsoConsider instance
 */
export class CardsCarousel extends Component<*, *> {
  /**
   * Implements propTypes().
   *
   * @return {Object} - propType object.
   */
  static propTypes = {
    related: PropTypes.array,
    carouselItemsToDisplay: PropTypes.object,
    viewport: PropTypes.string,
    extendStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    title: PropTypes.string,
    history: PropTypes.object,
    gtmSectionName: PropTypes.string.isRequired
  };

  /**
   * MapStateToProps implementation.
   * @return {object} new state object
   * @param {object} state object
   */
  static mapStateToProps(state: Object) {
    return {
      viewport: state.viewport.viewport
    };
  }

  pushGtm = item => {
    if (isWindow && isWindowProp('dataLayer')) {
      window.dataLayer.push(gtmAlsoConsiderClick(item));
    }
  };

  /**
   * Renders AlsoConsider.
   *
   * @return {JSX} rendered AlsoConsider.
   */

  render(): Element<*> | null {
    const {
      carouselItemsToDisplay,
      viewport,
      extendStyle,
      title,
      related,
      history
    } = this.props;

    if (!related || !related.length) {
      return null;
    }
    const isSmallDevice = viewport === 'xs' || viewport === 'sm' || false;

    return (
      <div className={styles.classAlsoConsider}>
        <h4>{title}</h4>
        <Carousel
          itemsToDisplay={carouselItemsToDisplay[viewport]}
          carouselType="lightSlider"
          extendStyle={extendStyle}
          showSlider={!isSmallDevice || false}
          showPagination={true}
          gtmSectionName={this.props.gtmSectionName}
        >
          {related.map((item, index) => (
            <Card
              cardLayout={'vertical'}
              key={index}
              id={valueOrNA(item, 'sourceId')}
              name={getDerivativeDisplayName(item.derivative)}
              make={valueOrNA(item.derivative, 'make')}
              range={valueOrNA(item.derivative, 'range')}
              price={parsedPrice(item.totalPrice)}
              year={item.year}
              distanceOrTown={distanceOrTown(item)}
              mileage={item.mileage || 0}
              fuelType={valueOrNA(item.derivative, 'fuelType')}
              doors={valueOrNA(item.derivative, 'doors')}
              transmission={valueOrNA(item.derivative, 'transmission')}
              image={item.images[0] || null}
              showPagination={true}
              paginationType={'default'}
              history={history}
              item={item}
              handleClick={this.pushGtm}
              gtmSectionName={this.props.gtmSectionName}
            />
          ))}
        </Carousel>
      </div>
    );
  }
}

export default connect(CardsCarousel.mapStateToProps, null)(CardsCarousel);



// WEBPACK FOOTER //
// ./src/Common/CardsCarousel/index.js